import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { wait } from "../utility/wait";

interface ChatNoveltyQuestionProps {
  noveltyValue: number | null;
  setNoveltyValue: React.Dispatch<React.SetStateAction<number | null>>;
  isAutoPageTurn?: boolean;
  questionnairePage: number;
  switchTab: (next: number) => void;
}

export const ChatNoveltyQuestion: React.FC<ChatNoveltyQuestionProps> = ({
  noveltyValue,
  setNoveltyValue,
  isAutoPageTurn,
  questionnairePage,
  switchTab,
}) => {
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setNoveltyValue(Number((event.target as HTMLInputElement).value));
    if (isAutoPageTurn) {
      await wait(100);
      switchTab(questionnairePage + 1);
    }
  };

  return (
    <>
      <Box sx={{ padding: "1rem" }}>
        <Typography variant="caption">
          先ほどのチャットで、ふと思い返したこと、小さな気づきや発見があったと感じましたか？
          もっとも当てはまるものを選んでください。
        </Typography>
      </Box>
      <Box sx={{ padding: "1rem" }}>
        <FormControl>
          <RadioGroup onChange={handleChange} value={noveltyValue}>
            <FormControlLabel
              value={7}
              control={<Radio />}
              label="7：思い返したことや気づきがたくさんあった"
            />
            <FormControlLabel value={6} control={<Radio />} label="6" />
            <FormControlLabel value={5} control={<Radio />} label="5" />
            <FormControlLabel value={4} control={<Radio />} label="4" />
            <FormControlLabel value={3} control={<Radio />} label="3" />
            <FormControlLabel value={2} control={<Radio />} label="2" />
            <FormControlLabel
              value={1}
              control={<Radio />}
              label="1：全くなかった"
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </>
  );
};
